import api from './api';

const getListFaqs = async (category, platform) => {
  const response = await api({
    method: 'GET',
    url: '/faqs',
    params: { category, platform },
  });

  return response;
};

export { getListFaqs };
